import { ReactNode,createContext, useState, } from "react";
import { useNavigate } from "react-router-dom";

import { toast, ToastContainer } from "react-toastify";

import api from "../services/api";

type AuthContextData = {
  user: UserProps | undefined;
  isAuthenticated: boolean;
  signIn: (credentials: SignInProps) => Promise<void>;
  signOut: () => void;
}

type UserProps = {
  id: number;
  nome: string;
  sobrenome: string;
  accessToken: string;
}

type SignInProps = {
  email: string;
  password: string;
}

type AuthProviderProps = {
  children: ReactNode;
}

type AuthResponse = {
  accessToken?: string;
  user?: {
    id: number;
    nome: string;
    sobrenome: string;
  };
  error?: string;
}


export const AuthContext = createContext({} as AuthContextData);

function AuthProvider({ children }: AuthProviderProps) {
  const [user, setUser] = useState<UserProps>();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const isAuthenticated = !!user;

  async function signIn({ email, password }: SignInProps): Promise<void> {
    try {
      setLoading(true);
      setError('');

      const response = await api.post<AuthResponse>('/auth', {
        email,
        password,
      });

      console.log('Resposta da API:', response.data);

      if(!response.data) {
        throw new Error('Resposta da API inválida');
      }

      if (response.data.error) {
       throw new Error(response.data.error);
      }

      if(!response.data.accessToken || !response.data.user) {
        toast.error("Usuário ou senha inválidos");
        throw new Error('Usuário ou senha inválidos');
      }

      const { accessToken, user } = response.data;

      localStorage.setItem('@seculos:token', JSON.stringify({ 
        nome: user.nome, sobrenome: user.sobrenome, accessToken,
      }));

      setUser({
        id: user.id,
        nome: user.nome,
        sobrenome: user.sobrenome, 
        accessToken,
      })

      toast.success(`Olá ${user.nome} ${user.sobrenome}, bem vindo ao sistema!`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      navigate('/painel/dashboard');

    } catch (err) { 
      toast.error("Erro ao fazer login. Por favor, tente novamente.");
      setUser(undefined);
      localStorage.removeItem('@seculos:token');
      return;
    }
  }

  async function signOut(): Promise<void> {
    const token = '@seculos:token';
    const routeSigin = '/painel/sign-admin';
    try {
      localStorage.removeItem(token);

      localStorage.removeItem('@seculos:user');
      sessionStorage.removeItem('@seculos:session');
      
      navigate(routeSigin);

      window.location.reload();

    } catch (err) {
      console.log(err, 'Erro ao deslogar.')
      navigate(routeSigin);
    }
  }

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, signIn, signOut}}>
      {children}
      <ToastContainer/>
    </AuthContext.Provider>
  );
}

export default AuthProvider;